<template>
  <div class="us-page">
    <banner
      img="https://zcts-web.oss-cn-shenzhen.aliyuncs.com/zc/cd730bbcd84f4f7fa4d6f1bd20bae0a8.jfif"
      :title="$t('contactUs')"
    />
    
    <div class="us-container" v-loading="loading">
      <div class="us-wrapper">
        
        <!-- 地图展示模块 -->
        <div class="content-block map-block">
          <div class="block-header">
            <div class="icon-box">
              <i class="el-icon-location"></i>
            </div>
            <div class="block-header__text">
              <h3>{{ $t("address") }}</h3>
              <p>{{ companyData.address || $t("Loading") }}</p>
            </div>
          </div>
          <div class="map-body">
            <div id="container"></div>
          </div>
        </div>

        <!-- 表单与联系信息主体 (同页平铺) -->
        <div class="content-block contact-block">
          <!-- 左侧：表单 -->
          <div class="form-section">
            <div class="section-title">
              <h2>{{ $t("contactUs") }}</h2>
              <div class="title-bar"></div>
            </div>
            
            <el-form
              ref="contactForm"
              :model="form"
              :rules="rules"
              label-position="top"
              class="contact-form"
            >
              <div class="form-row">
                <el-form-item :label="$t('nickname')" prop="name">
                  <el-input v-model="form.name" :placeholder="$t('enterYourName')" clearable />
                </el-form-item>
                <el-form-item :label="$t('phone')" prop="phone">
                  <el-input v-model="form.phone" :placeholder="$t('enterYourPhone')" clearable />
                </el-form-item>
              </div>

              <div class="form-row">
                <el-form-item :label="$t('email')" prop="email">
                  <el-input v-model="form.email" :placeholder="$t('enterYourEmail')" clearable />
                </el-form-item>
                <el-form-item :label="$t('subject')" prop="theme">
                  <el-input v-model="form.theme" :placeholder="$t('enterSubject')" clearable />
                </el-form-item>
              </div>

              <el-form-item :label="$t('cooperationIntent')" prop="cooperationIntent">
                <el-radio-group v-model="form.cooperationIntent" class="intent-group">
                  <el-radio
                    v-for="item in intentOptions"
                    :key="item.value"
                    :label="item.value"
                  >{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item :label="$t('leaveMessage')" prop="leaveWord">
                <el-input
                  v-model="form.leaveWord"
                  type="textarea"
                  :rows="4"
                  :placeholder="leavePlaceholder"
                />
              </el-form-item>

              <el-form-item class="submit-item">
                <el-button
                  type="primary"
                  :loading="submitting"
                  :disabled="submitting"
                  @click="submitForm"
                  class="submit-btn"
                >
                  <span>{{ $t("send") }}</span>
                </el-button>
              </el-form-item>
            </el-form>

            <contact-verify-dialog
              :visible.sync="verifyVisible"
              theme-color="#024190"
              :title="$t('verifyDialogTitle')"
              :description="$t('verifyDialogDesc')"
              :slide-text="$t('slideVerifyText')"
              :success-text="$t('verificationSuccess')"
              :cancel-text="$t('cancel')"
              @success="onVerifySuccess"
            />
          </div>

          <!-- 右侧：联系信息 -->
          <div class="info-section">
            <div class="section-title">
              <h2>{{ $t("contactInfo") || 'Get in Touch' }}</h2>
              <div class="title-bar"></div>
            </div>
            
            <ul class="info-list">
              <li>
                <div class="icon-wrap">
                  <i class="el-icon-location-outline"></i>
                </div>
                <div class="info-content">
                  <h4>{{ $t("address") }}</h4>
                  <p>{{ companyData.address || '-' }}</p>
                </div>
              </li>
              <li>
                <div class="icon-wrap">
                  <i class="el-icon-phone-outline"></i>
                </div>
                <div class="info-content">
                  <h4>{{ $t("phone") }}</h4>
                  <p>{{ companyData.phone || '-' }}</p>
                  <p class="sub-text">{{ $t("mondayToFriday") }} 8:30 - 17:30</p>
                </div>
              </li>
              <li>
                <div class="icon-wrap">
                  <i class="el-icon-message"></i>
                </div>
                <div class="info-content">
                  <h4>{{ $t("email") }}</h4>
                  <p>{{ companyData.email || '-' }}</p>
                  <p class="sub-text">{{ $t("contact") }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
  securityJsCode: "ddc0d41368b22a4ec0f846887ba2d8a2",
};
import { getMsg } from "@/api/company.js";
import { addContactPage } from "@/api/contact.js";
import ContactVerifyDialog from "@/components/ContactVerifyDialog.vue";

export default {
  components: {
    Banner,
    ContactVerifyDialog,
  },
  data() {
    return {
      loading: false,
      submitting: false,
      verifyVisible: false,
      map: null,
      form: {
        name: "",
        email: "",
        phone: "",
        theme: "",
        cooperationIntent: "",
        leaveWord: "",
      },
      rules: {
        name: [
          { required: true, message: this.$t("nameRequired"), trigger: "blur" },
          { min: 2, max: 30, message: this.$t("nameLengthBetween2And30"), trigger: "blur" },
        ],
        phone: [
          { required: true, validator: this.validatePhone, trigger: "blur" },
        ],
        email: [
          { validator: this.validateEmail, trigger: "blur" },
        ],
        theme: [
          { required: true, message: this.$t("companyRequired"), trigger: "blur" },
          { min: 2, max: 100, message: this.$t("subjectLengthLimit"), trigger: "blur" },
        ],
        cooperationIntent: [
          { required: true, message: this.$t("selectIntent"), trigger: "change" },
        ],
        leaveWord: [
          { required: true, message: this.$t("enterMessageContent"), trigger: "blur" },
          { min: 10, max: 500, message: this.$t("messageContentLengthLimit"), trigger: "blur" },
        ],
      },
      companyData: {},
    };
  },
  computed: {
    intentOptions() {
      return [
        { value: "1", label: this.$t("intentLogistics") },
        { value: "2", label: this.$t("intentTrade") },
        { value: "3", label: this.$t("intentSupplier") },
        { value: "4", label: this.$t("intentOther") },
      ];
    },
    leavePlaceholder() {
      const map = {
        1: this.$t("leaveHintLogistics"),
        2: this.$t("leaveHintTrade"),
        3: this.$t("leaveHintSupplier"),
        4: this.$t("leaveHintOther"),
      };
      return map[this.form.cooperationIntent] || this.$t("leaveHintDefault");
    },
  },
  methods: {
    validatePhone(rule, value, callback) {
      const raw = (value || "").trim();
      if (!raw) {
        callback(new Error(this.$t("phoneRequired")));
        return;
      }
      const normalized = raw.replace(/[\s-]/g, "");
      const chinaMobile = /^(?:\+?86)?1[3-9]\d{9}$/.test(normalized);
      const intlMobile = /^\+[1-9]\d{7,14}$/.test(normalized);
      if (chinaMobile || intlMobile) {
        callback();
      } else {
        callback(new Error(this.$t("invalidPhone")));
      }
    },
    validateEmail(rule, value, callback) {
      const raw = (value || "").trim();
      if (!raw) {
        callback();
        return;
      }
      const ok = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(raw);
      if (ok) {
        callback();
      } else {
        callback(new Error(this.$t("enterValidEmail")));
      }
    },
    resetFormAfterSubmit() {
      this.form = {
        name: "",
        phone: "",
        email: "",
        theme: "",
        cooperationIntent: "",
        leaveWord: "",
      };
      this.$nextTick(() => {
        this.$refs.contactForm && this.$refs.contactForm.clearValidate();
      });
    },
    doSubmitContact() {
      this.submitting = true;
      addContactPage(this.form)
        .then(() => {
          this.$message.success(this.$t("formSubmitSuccess"));
          this.resetFormAfterSubmit();
        })
        .catch(() => {
          this.$message.error(this.$t("submitFailed"));
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    onVerifySuccess() {
      this.doSubmitContact();
    },
    submitForm() {
      if (this.submitting) return;
      this.$refs.contactForm.validate((valid) => {
        if (!valid) {
          this.$message.error(this.$t("completeFormBeforeSubmitting"));
          return false;
        }
        this.verifyVisible = true;
      });
    },
    initMap() {
      const currentLang = localStorage.getItem("locale") || "zh-CN";
      AMapLoader.load({
        key: "f7a1a6c0ce21a1c6f9f21d49b0803808",
        version: "2.0",
        plugins: [],
        language: currentLang === "en-US" ? "en" : "zh_cn",
      })
        .then((AMap) => {
          const centerPoint = [
            Number(this.companyData.longitude || 113.9),
            Number(this.companyData.latitude || 22.5),
          ];
          this.map = new AMap.Map("container", {
            viewMode: "3D",
            zoom: 15,
            center: centerPoint,
            language: currentLang === "en-US" ? "en" : "zh_cn",
          });
          const marker = new AMap.Marker({
            position: centerPoint,
            title: currentLang === "en" ? "Current Location" : "当前位置",
            icon: new AMap.Icon({
              size: new AMap.Size(25, 34),
              image: require("../assets/img/mark_r.png"),
              imageSize: new AMap.Size(25, 34),
            }),
          });
          this.map.add(marker);
        })
        .catch((e) => {
          console.error("地图加载失败：", e);
        });
    },
    init() {
      getMsg().then((res) => {
        this.companyData = res.data || {};
        this.initMap();
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.us-page {
  width: 100%;
  min-height: 100vh;
  background: url("https://zcts-web.oss-cn-shenzhen.aliyuncs.com/img2/bg_all.jpg") no-repeat center fixed;
  background-size: cover;
  padding-bottom: 60px;
}

.us-container {
  width: 100%;
  padding-top: 40px;
}

.us-wrapper {
  width: 1425px;
  margin: 0 auto;
  background-color: #fff;
  padding: 40px 60px;
  box-sizing: border-box;
}

/* 通用区块间距 */
.content-block {
  margin-bottom: 50px;
  &:last-child {
    margin-bottom: 0;
  }
}

/* 地图区块 */
.map-block {
  .block-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;

    .icon-box {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #024190;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      flex-shrink: 0;
    }

    &__text {
      h3 {
        margin: 0 0 4px;
        font-size: 18px;
        font-weight: 600;
        color: #1f2d3d;
      }
      p {
        margin: 0;
        font-size: 14px;
        color: #606266;
      }
    }
  }

  .map-body {
    width: 100%;
    height: 450px;
    border-radius: 8px;
    overflow: hidden;
  }
}

#container {
  width: 100%;
  height: 100%;
}

/* 联系我们与信息区块 */
.contact-block {
  display: flex;
  gap: 60px;
  align-items: flex-start;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.section-title {
  margin-bottom: 25px;
  
  h2 {
    font-size: 24px;
    font-weight: 700;
    color: #1f2d3d;
    margin: 0 0 8px 0;
  }

  .title-bar {
    width: 40px;
    height: 4px;
    background: #024190;
    border-radius: 2px;
  }
}

/* 左侧表单 */
.form-section {
  flex: 1.3;

  .form-row {
    display: flex;
    gap: 10px;
    
    .el-form-item {
      flex: 1;
    }
  }

  ::v-deep .el-form-item__label {
    padding-bottom: 6px;
    font-weight: 500;
    color: #303133;
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-radius: 4px;
    border-color: #dcdfe6;
    transition: border-color 0.2s;
    
    &:focus {
      border-color: #024190;
    }
  }

  .submit-item {
    margin-top: 15px;
    margin-bottom: 0;
  }

  .intent-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding-top: 6px;

    .el-radio {
      margin-right: 0;
      white-space: normal;
      line-height: 1.5;
      width: 100%;

      &.is-checked {
        ::v-deep .el-radio__label {
          color: #024190;
        }

        ::v-deep .el-radio__inner {
          border-color: #024190;
          background-color: #024190;
        }
      }
    }
  }

  .submit-btn {
    width: 100%;
    height: 50px;
    background-color: #024190;
    border: none;
    border-radius: 4px;
    font-size: 16px !important;
    font-weight: 600 !important;
    letter-spacing: 1px;
    transition: opacity 0.2s;
    color: #fff !important;

    &:hover {
      opacity: 0.9;
    }
  }
}

/* 右侧联系信息 */
.info-section {
  flex: 0.75;

  .info-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 28px;
    margin-top: 35px;

    li {
      display: flex;
      align-items: flex-start;
      gap: 18px;

      .icon-wrap {
        width: 44px;
        height: 44px;
        border-radius: 8px;
        background: #f0f5fc;
        color: #024190;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        flex-shrink: 0;
        transition: all 0.3s;
      }

      &:hover .icon-wrap {
        background: #024190;
        color: #fff;
      }

      .info-content {
        h4 {
          margin: 0 0 6px;
          font-size: 20px;
          font-weight: 500;
          color: #1f2d3d;
        }

        p {
          margin: 0;
          font-size: 18px;
          line-height: 1.6;
          color: #606266;
          word-break: break-all;
        }

        .sub-text {
          font-size: 14px;
          color: #909399;
          margin-top: 2px;
        }
      }
    }
  }
}

/* 响应式媒体查询适配 */
@media screen and (max-width: 1450px) {
  .us-wrapper {
    width: 95%;
    padding: 30px 20px;
  }
}

@media screen and (max-width: 992px) {
  .contact-block {
    flex-direction: column;
    gap: 40px;
  }
  .form-row {
    flex-direction: column;
    gap: 0;
  }
}
</style>